import ShoppingBagOutlineIcon from "@ancon/wildcat-ui/shared/icons/shopping-bag-outline.svg";
import clsx from "clsx";
import { useEffect, useState } from "react";

import styles from "./CartButton.module.scss";
import Button from "../support/Button";

export default function CartButton() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartIconAnimate, setCartIconAnimate] = useState(false);

  function handleCartToggleClick() {
    setIsCartOpen(!isCartOpen);
    setCartIconAnimate(!cartIconAnimate);
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setIsCartOpen(!isCartOpen);
      setCartIconAnimate(!cartIconAnimate);
    }, 2000);

    return () => clearInterval(interval);
  }, [isCartOpen, cartIconAnimate]);

  return (
    <Button
      size="large"
      variant={isCartOpen ? "tertiary" : "secondary"}
      onClick={handleCartToggleClick}
      className={clsx(styles.cartButton, {
        [styles.cartOpen]: isCartOpen,
      })}
    >
      <ShoppingBagOutlineIcon
        // @ts-ignore
        className={clsx({
          [styles.wobbleBottom]: cartIconAnimate,
        })}
      />
      <span>Cart</span>
      <span>&middot;</span>
      <span>{5}</span>
    </Button>
  );
}
